import {
  ContactUsState,
  ADD_CONTACT_US,
  ADD_CONTACT_US_SUCCESS,
  ADD_CONTACT_US_FAILURE,
  RESET_CONTACT_US,
  ContactUsActionTypes,
} from "../types/contactTypes";

const initialState: ContactUsState = {
  contactUsSuccess: null,
  contactUsError: null,
  contactUsLoading: false,
};

export const contactUsReducer = (
  state = initialState,
  action: ContactUsActionTypes
): ContactUsState => {
  switch (action.type) {
    case ADD_CONTACT_US: {
      return {
        ...state,
        contactUsSuccess: null,
        contactUsError: null,
        contactUsLoading: true,
      };
    }

    case ADD_CONTACT_US_SUCCESS: {
      return {
        ...state,
        contactUsSuccess: action.payload?.message,
        contactUsError: null,
        contactUsLoading: false,
      };
    }

    case ADD_CONTACT_US_FAILURE: {
      return {
        ...state,
        contactUsError: action.payload,
        contactUsSuccess: null,
        contactUsLoading: false,
      };
    }

    case RESET_CONTACT_US: {
      return {
        ...state,
        contactUsSuccess: null,
        contactUsError: null,
        contactUsLoading: false,
      };
    }

    default:
      return state;
  }
};
